export default __webpack_public_path__ + "static/media/loader.e8c59371.svg";